import React from 'react';
import PropTypes from 'prop-types';
import { H6 } from '@luigiclaudio/ga-baseline-ui/typography';

const Title = ({ title }) => {
    return <H6 color="muted">{title}</H6>;
};

Title.propTypes = {
    title: PropTypes.string.isRequired,
};

export default Title;
